import { axios } from '@/utils/request'

export function login (parameter) {
  return axios({
    url: '/user/login2',
    method: 'post',
    data: parameter
  })
}

export function logout (logoutToken) {
  return axios({
    url: '/user/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      token: logoutToken
    }
  })
}

export function getInfo () {
  return axios({
    url: '/user/info',
    method: 'get'
  })
}

export function updatePassword (params) {
  return axios({
    url: '/sys/user/updatePassword',
    method: 'put',
    data: params
  })
}

export function changePassword (params) {
  return axios({
    url: '/sys/user/changePassword',
    method: 'put',
    data: params
  })
}

export function updateUser (params) {
  return axios({
    url: '/sys/user/update',
    method: 'put',
    data: params
  })
}

export function recharge (capitalId, params) {
  return axios({
    url: '/capital/recharge/' + capitalId,
    params: params,
    method: 'put'
  })
}

export function deductDiffAmount (capitalId, params) {
  return axios({
    url: '/capital/deduct/' + capitalId,
    params: params,
    method: 'put'
  })
}

export function approveStore (id, auditStatus) {
  return axios({
    url: '/sys/account/store/approve/' + id,
    method: 'put',
    params: { auditStatus: auditStatus }
  })
}
